import { useState } from "react";
import { Outlet, useNavigate } from "react-router";
import {
  DialogPanel,
  Transition,
  TransitionChild,
  Dialog,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Box } from "../shared/utils";
import Footer from "../shared/Footer";
import { logoDarkImage } from "../shared/images";
import { useCheckHeartBeat } from "../queries/auth";
import { useAuthStore } from "../store/useAuthStore";
import { queryClient } from "../queries/client";
import { TopBarWrapper } from "./TopBar/TopBarWrapper";

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { error, isError } = useCheckHeartBeat(true);
  const { clear } = useAuthStore();
  const navigate = useNavigate();

  if (isError) {
    console.log("error: ", error);
    queryClient.clear();
    clear();
    navigate("/login");
  }

  return (
    <div>
      <Transition show={sidebarOpen}>
        <Dialog className="relative z-40 lg:hidden" onClose={setSidebarOpen}>
          <TransitionChild
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-900/80" />
          </TransitionChild>

          <div className="fixed inset-0 flex">
            <TransitionChild
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <DialogPanel className="relative mr-16 flex w-full max-w-xs flex-1">
                <TransitionChild
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                    <button
                      type="button"
                      className="-m-2.5 p-2.5"
                      onClick={() => {
                        setSidebarOpen(false);
                      }}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </TransitionChild>

                <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                  <div className="flex h-16 shrink-0 items-center">
                    {logoDarkImage ? (
                      <img
                        className="h-8 w-auto"
                        src={logoDarkImage}
                        alt="hissa_logo"
                      />
                    ) : (
                      <h2 className="text-3xl font-semibold text-secondary">
                        {"hissa"}
                      </h2>
                    )}
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </Dialog>
      </Transition>

      <div
        className={`flex-1 scrollbar-hide overflow-x-clip overflow-hidden transition-all duration-300 ease-in-out`}
        id="outlet"
      >
        <div className="relative w-full ">
          {/* <div className="fixed top-0 right-0 left-0 z-40 bg-white shadow-box">
            <div
              className={`flex h-16 shrink-0 items-center gap-x-4 px-4 sm:gap-x-6 sm:px-6 lg:px-8 ${"md:ml-16"}`}
            >
              <form
                className="relative flex flex-1"
                action="#"
                method="GET"
              ></form>
              <div
                className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
                aria-hidden="true"
              />
              <div className="hidden lg:block">
                <FlyoutProfile />
              </div>
            </div>
          </div> */}
          <TopBarWrapper />

          <Box className="py-4 pt-14 sm:px-[60px] px-4 pb-20 mx-auto">
            <Outlet />
          </Box>
          <div className=""></div>
          <div className="absolute bottom-0 w-full mt-6 ">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}
